export default "__VITE_ASSET__CgUf1Ksb__"